import { useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { ProjectHoursBillingBy } from '@work4all/models/lib/Enums/ProjectHoursBillingBy.enum';

import { ProjectHourBillingOverlayFormValue } from '../types';

import { useNumberOfProjectHours } from './use-number-of-project-hours';

export const useInputsValid = (
  form: UseFormReturn<ProjectHourBillingOverlayFormValue>
) => {
  const { filters, settings } = form.watch();

  const numberOfProjectHours = useNumberOfProjectHours(filters);

  return useMemo(() => {
    if (numberOfProjectHours === 0) {
      return false;
    }

    if (
      settings.billingBy === ProjectHoursBillingBy.CUSTOMER &&
      settings.customerCodes.length === 0
    ) {
      return false;
    }

    if (
      settings.billingBy === ProjectHoursBillingBy.ORDER_CONFIRMATION &&
      settings.orderConfirmationCodes.length === 0
    ) {
      return false;
    }

    // if (
    //   settings.billingType === ProjectHoursBillingType.GROUPED_BY_USER &&
    //   !settings.articleCode
    // ) {
    //   return false;
    // }

    return true;
  }, [
    numberOfProjectHours,
    settings.billingBy,
    settings.customerCodes.length,
    settings.orderConfirmationCodes.length,
  ]);
};
